import React from "react";
import PropTypes from "prop-types";
import {default as MUIDialog} from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import {ActionButtons} from "components/Shared";


const Dialog = ({
  title,
  children,
  buttonPropSets,
  onClick,
  onClose,
  ...otherProps
}) => title && (
  <MUIDialog
    {...otherProps}
    {...{onClose}}
    PaperComponent={Card}
    fullWidth
  >
    <CardHeader {...{title}}/>
    <CardContent>
      {children}
    </CardContent>
    <ActionButtons
      buttonPropSets={buttonPropSets || [
        {
          onClick,
          children: "Confirm",
        },
        {
          onClick: onClose,
          children: "Cancel",
        }
      ]}
    />
  </MUIDialog>
);

Dialog.defaultProps = {
  title: "",
  buttonPropSets: null,
};

//All Mui Dialog props https://material-ui.com/components/dialogs/
Dialog.propTypes = {
  //Text that will be in the Dialog header if not provided then this component will return null
  title: PropTypes.string,
  //Content of Dialogue
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  //If you need more sophisticated control over the dialog buttons use this to define them, 
  //passing onClick and onClose will suffice in most use cases
  buttonPropSets: PropTypes.array,
  //Callback fired when the "Confirm" button is clicked
  onClick: PropTypes.func, 
  //Callback fired when the "Cancel" button is clicked, esc is pressed or user clicks away
  onClose: PropTypes.func,
};

export default Dialog;